import React from "react";
import { Route, Routes } from "react-router-dom";
import UserList from "../../component/User/User/UserList";
import UserDetail from "../../component/User/User/UserDetail";
import UserForm from "../../component/User/User/UserForm";

function UserPage() {
  return (
    <Routes>
      <Route path="/*" element={<UserList />} />
      <Route path="/:id" element={<UserDetail />} />
      <Route path="/edit/:id" element={<UserForm isEdit={true} />} />
      <Route path="/new" element={<UserForm isEdit={false} />} />
      {/* <Route path="/:id" element={<Detail />} />
      <Route path="/edit/:id" element={<Form isEdit={true} />} />
      <Route path="/new" element={<Form isEdit={false} />} /> */}
    </Routes>
  );
}

export default UserPage;
